
    <!-- add the triggering mechanism so when overlay is clicked, it clicks the image underneath -->

  jQuery('.product-thumbnail-image-hover').on('click',function(){ 
  jQuery(this).prev().trigger('click');
  });
  

  <!-- add script to change Custom Option value on QTY Change -->
   jQuery(document).ready(function(){
    //change it incase it's set already
  jQuery('input#Quantity-product-template, input#Quantity-').on('change',function(){
  jQuery('input[name="properties[Quantity]"]').val(jQuery(this).val());
  });
    if(jQuery('#Quantity-product-template').val() > 1){
      setTimeout(function(){
     jQuery('input[name="properties[Quantity]"]').val(jQuery('#Quantity-product-template').val());
        },500);
    }
    });

       console.log('this is the document referrer');
   console.log(document.referrer);
